import { render, staticRenderFns } from "./TemplateApproval.vue?vue&type=template&id=48bb91e4&scoped=true&"
import script from "./TemplateApproval.vue?vue&type=script&lang=js&"
export * from "./TemplateApproval.vue?vue&type=script&lang=js&"
import style0 from "./TemplateApproval.vue?vue&type=style&index=0&id=48bb91e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb91e4",
  null
  
)

component.options.__file = "TemplateApproval.vue"
export default component.exports